// extracted by mini-css-extract-plugin
export default {"recentPayments":"SCQN1HA2VETBVhrd9MDV","link":"ebQakBmboYuMiZB2nDxh"};